/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Referral {
    export class ReferralService {
        static $inject = [
            "meevo.components.common.DataService",
            "meevo.AppSettings",
            "meevo.components.tracking.TrackingService",
            "meevo.components.modal.ModalService",
            "$q",
            "$translate",
            "meevoDateFilterFilter"
        ];

        constructor(
            private dataService,
            private appSettings,
            private trackingService: Meevo.Components.Tracking.ITrackingService,
            private modalService: Meevo.Components.Modal.IModalService,
            private $q,
            private $translate,
            private meevoDateFilterFilter) {

        }

        displayReferralsSinceClientLastVisit(clients: any): angular.IPromise<boolean> {
            if (this.appSettings.APP_BUSINFOSETTINGS.registerSettings.showReferralsSinceClientLastVisit) {
                var clientIds = _(clients).pluck('id');
                if (clientIds.length > 0) {
                    let request: any = {
                        clientIds: clientIds
                    };
                    return this.dataService.customMethodData(`api/Client/Referral/List`, 'POST', request)
                        .then((referralsResponse) => {
                            if (referralsResponse && referralsResponse.data && referralsResponse.data.length > 0) {
                                let referralsResponseData = referralsResponse.data;
                                var referralsMsgHTML = '';
                                var referralGroup = _(referralsResponseData).groupBy('referrerClientId');
                                _(Object.keys(referralGroup)).each(keyReferrerClientId => {
                                    let referrals = referralGroup[keyReferrerClientId];
                                    let referralsMsg: any[] = [];
                                    _(referrals).each(referral => {
                                        let msg = referral.displayName + ' - ' + this.meevoDateFilterFilter(moment(referral.firstVisitDate).toDate());
                                        referralsMsg.push(msg);
                                    });
                                    let client: any = _(clients).findWhere({ id: keyReferrerClientId });
                                    if (client) {
                                        referralsMsgHTML += `${this.$translate.instant('MESSAGE_REFERRAL_CLIENT_SINCE_LAST_VISIT', { clientDisplayName: client.firstName + ' ' + client.lastName })}
                                                <br><ul><li>${referralsMsg.join('</li><li>')}</li></ul><br>`;
                                    }
                                });

                                return this.modalService.info(referralsMsgHTML, null, false, undefined, this.$translate.instant('LABEL_THANK_YOU'));
                            }
                        });
                }
            }
            return this.$q.resolve();
        }
    }

    angular.module("meevo.plugins.referral")
        .service("meevo.plugins.referral.ReferralService", ReferralService); ;
}